import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { GroupsQuery } from '@shared/interfaces/groups/groups-query.interface';
import { GroupDto } from '@shared/interfaces/dtos/groups';
import { ObjectUtils } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class GroupsService extends BaseHttpService {
  protected endPoint: string = 'Global/Groupes';

  public fetchGroups(query?: GroupsQuery): Observable<GroupDto[]> {
    ObjectUtils.removeFalsyEntries(query);

    return this.http.get<GroupDto[]>(this.buildURL(), { params: { ...query } });
  }
}
